<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jbd0jo/tc-custom/9781488004056.jpg?1740636877632" alt="This image is the cover for the book Bound by One Scandalous Night, The Scandalous Summerfields"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bound by One Scandalous Night, The Scandalous Summerfields
      </h1>
      <p class="bookDescription body article font2">
        <b>Marrying a stranger </b><br/><br/>On the eve of battle, Lieutenant Edmund Summerfield rescues mysterious Amelie Glenville from attack by marauding soldiers. Heady from the anticipation and uncertainty in the air, they spend the night together, but their scandalous actions have one inescapable consequence! <br/><br/>The illegitimate son of an aristocrat, Edmund won't consign his unborn child to the same fate, so he offers Amelie marriage. With a honeymoon spent weathering a storm of scandal, can these two strangers hope to turn their convenient marriage into something real?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Gaston
      </h2>
      
      <p class="authorDescription body article">Diane Gaston&#39;s dream job had always been to write romance novels. One day she dared to pursue that dream and has never looked back. Her books have won Romance&#39;s highest honours: the RITA Award, the National Readers Choice Award, Holt Medallion, and Golden Heart. She lives in Virginia with her husband and three very ordinary house cats. Diane loves to hear from readers and friends. Visit her website at:&#160;<a href="http://dianegaston.com">https://www.dianegaston.com/</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8bcb9ad4